<template>
    <div>
        <slot
            :params="params"
            :formModal="formModal"
            :crearPlan="crearPlan"
            :crearArea="crearArea"
            :crearAsignatura="crearAsignatura"
            :selectArea="selectArea"
            :change="change"
            :data="data"
            :openAsignaturaModal="openAsignaturaModal"
            :actualizarAsignatura="actualizarAsignatura"
            :openAreaModal="openAreaModal"
            :actualizarArea="actualizarArea"
            :nuevoAreaModal="nuevoAreaModal">
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';
import selectpicker from 'bootstrap-select';
import draggable from 'vuedraggable';

export default {
    data() { return {
        params: {},
        formModal: {
          grados: [],
          grado_id: 0
        },
        data: {},
        area_id: -1,
    }},
    mounted() {
        const vm = this;
        const crearPlanId = $('#crearPlanId');
        const crearPlanForm = $('#crearPlanForm');
        const nuevoPlanButton = $('#nuevoPlanButton');
        const selectPlan = $('#plan_id');
        const selectPrograma = $('#programa_id');
        const selectInstitucion = $('#institucion_id');
        const selectEstilo = $('#estilo');

        nuevoPlanButton.prop('disabled', true);
        selectInstitucion.on('change', function() {
            nuevoPlanButton.prop('disabled', true);
        });
        selectPrograma.on('change', function() {
            nuevoPlanButton.prop('disabled', false);
        });

        selectPlan.on('change', function() {
            const plan_id = selectPlan.selectpicker('val');
            if(plan_id) {
                vm.leerPlan(plan_id);
            }
        });

        selectEstilo.selectpicker('val', 'neutro');
    },
    methods: {
        agregarPlanAlSelect(plan) {
            const selectPlan = $('#plan_id');
            selectPlan.append('<option value="'+plan.id+'">'+plan.nombre+'</option>');
            selectPlan.selectpicker('val', plan.id);
            selectPlan.selectpicker('refresh');
        },
        leerPlan(plan_id) {
            axios.get('asignaturas/leerPlan/'+plan_id).then(res => {
                this.data = res.data.plan;
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearPlan() {
            this.formModal.programa_id = $('#programa_id').val();
            axios.post('/asignaturas/crearPlan', this.formModal).then(res => {
                this.data = res.data.plan;
                this.agregarPlanAlSelect(this.data);
                this.$emit('kiraModalFormClose');
                this.formModal = {};

                toastr["success"]('Nuevo plan de estudio agregado', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearArea() {
            this.formModal.plan_estudios_id = this.data.id;
            axios.post('/asignaturas/crearArea', this.formModal).then(res => {
                this.data.areas = this.data.areas.concat(res.data.area);
                this.$emit('kiraModalFormClose');
                this.formModal = {};

                toastr["success"]('Nueva area agregada', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        crearAsignatura() {
            this.formModal.area_id = this.area_id;
            axios.post('/asignaturas/crearAsignatura', this.formModal).then(res => {
                const index = this.data.areas.findIndex(a => a.id == this.area_id);
                this.data.areas[index].asignaturas = this.data.areas[index].asignaturas.concat(res.data.asignatura);
                this.$emit('kiraModalFormClose');
                this.formModal = {};

                toastr["success"]('Nuevo asignatura agregada', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        selectArea(area_id) {
            this.formModal = {};
            this.area_id = area_id;
        },
        async change(event, area) {
          const request = [];
          let count = 0;

          for (const asignatura of area.asignaturas) {
            request.push({
              asignatura_id: asignatura.id,
              area_id: area.id,
              order: count
            });

            count++;
          }

          await Axios.post('/asignaturas/actualizarOrden', request).then(resp => resp.data);
        },
        openAsignaturaModal(asignatura) {
            this.formModal = asignatura;
            const editarModal = $('#editarAsignatura');
            editarModal.modal('show');
        },
        openAreaModal(area) {
            this.formModal = area;
            const editarModal = $('#editarArea');
            editarModal.modal('show');
        },
        actualizarAsignatura() {
            axios.post('/asignaturas/actualizarAsignatura/'+this.formModal.id, this.formModal).then(res => {
                //const index = this.data.areas.findIndex(a => a.id == this.area_id);

                this.$emit('kiraModalFormClose');
                this.formModal = {};

                toastr["success"]('Asignatura actualizada', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        actualizarArea() {
            axios.post('/asignaturas/actualizarArea/'+this.formModal.id, this.formModal).then(res => {
                //const index = this.data.areas.findIndex(a => a.id == this.area_id);

                this.$emit('kiraModalFormClose');
                this.formModal = {};

                toastr["success"]('Area actualizada', "Éxito");
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado', 'Error');
            });
        },
        nuevoAreaModal() {
            this.formModal = {};
        }
    },
    components: {
		draggable,
	}
}
</script>
